import { computed, inject } from '@angular/core';
import { signalStore, type, withComputed, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import { withEntitiesLoadingCall } from '@ngrx-traits/signals';
import { map } from 'rxjs';
import { withCallStatus } from '@ngrx-traits/signals';
import { withEntitiesLocalSort, withLogger } from '@ngrx-traits/signals';
import { CaseType, CaseTypeService } from '..';

const caseTypeConfig = entityConfig({
  entity: type<CaseType>(),
  collection: 'caseType',
});

export const CaseTypeStore = signalStore(
  withEntities(caseTypeConfig),
  withCallStatus(caseTypeConfig, {
    initialValue: 'init',
  }),
  withEntitiesLocalSort(
    { entity: type<CaseType>(), collection: caseTypeConfig.collection },
    {
      defaultSort: { field: 'name', direction: 'asc' },
    }
  ),
  withLogger({
    name: 'CaseTypeStore',
    showDiff: true,
  }),
  withProps(() => ({
    _caseTypeService: inject(CaseTypeService),
  })),
  withEntitiesLoadingCall(({ _caseTypeService }) => ({
    collection: caseTypeConfig.collection,
    fetchEntities: () =>
      _caseTypeService.loadCaseTypes().pipe(
        map((response) => ({
          entities: response.result,
          total: response.count,
        }))
      ),
  })),
  withComputed(({ caseTypeEntities }) => ({
    options: computed(() => caseTypeEntities().map(caseTypeToOption)),
  }))
);

const caseTypeToOption = (type: CaseType) => ({
  value: type.id.toString(),
  label: type.name,
  metadata: type,
});
